import { useCallback } from "react";
import { Node } from "@xyflow/react";

import { useDeleteNodes } from "../../hooks/useDeleteNodes";
import useUpdateNode from "../../hooks/useUpdateNode";

export function useSidebarEventHandlers({ node }: { node: Node }) {
  const { id } = node;

  const { onNodesDelete } = useDeleteNodes();
  const updateNodeAndSave = useUpdateNode();

  const onDeleteStep = useCallback(() => {
    if (node) {
      onNodesDelete([node]);
    }
  }, [onNodesDelete, node]);

  const onRemoveZap = useCallback(() => {
    updateNodeAndSave({
      id,
      data: {
        zapId: undefined,
        isExpanded: undefined,
      },
    });
  }, [updateNodeAndSave, id]);

  return {
    onRemoveZap,
    onDeleteStep,
  };
}
